import { connect, MapStateToProps } from 'react-redux';
import { Props } from './FolderList';
import { getFolderStream, getHasOnlyOneChunkOfGroupFoldersToLoad } from '../../redux/selectors';
import { AddToGroupsPanelStoreSlice } from '../../redux/types';

type StateProps = Pick<
  Props,
  'streamId' | 'folders' | 'isFetching' | 'hasMore' | 'hasOnlyOneChunkOfGroupFoldersToLoad'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AddToGroupsPanelStoreSlice> = (
  state,
  ownProps
) => {
  const { streamId, folders, isFetching, hasMore } = getFolderStream(
    state,
    ownProps.deviationId,
    ownProps.submissionType,
    ownProps.groupId
  );
  const hasOnlyOneChunkOfGroupFoldersToLoad = getHasOnlyOneChunkOfGroupFoldersToLoad(
    state,
    ownProps.submissionType,
    ownProps.groupId
  );
  return {
    streamId,
    folders,
    isFetching,
    hasMore,
    hasOnlyOneChunkOfGroupFoldersToLoad,
  };
};

export default connect(mapStateToProps);
